define([
	"dojo/_base/array",
	"dojo/promise/all",
	"csi/core/SpecBuilder",
	"csi/def",
	"csi/heading/_base",
	"csi/heading/Spec",
	"csi/heading/Specs",
	"csi/locale",
	"csi/property/ColumnGenerator",
	"csi/view",
	"csi/xml",
	"./CatalogProperties"
], function(array, all, SpecBuilder, def, csiHeading, Spec, Specs, locale, ColumnGenerator, csiView, xml) {

	var PATH = xml.path("MasterProduct");

	// ColumnGenerator: used to generate property layout should be converted to widget)
	var _cg = new ColumnGenerator({
		bValidValues: true
	});

	// csiView.Widget: views for summary and detail property views
	var _viewDetails;
	var _viewSummary;

	return {
		addPaths: function(/*String[]*/paths) {
			// summary: add paths from summary and details views - need to prepend path to MasterProduct
			if (_viewSummary && _viewDetails) {
				var a = [];

				def.getHeadingsDependencyPaths(_viewSummary.defView.m_headings, a);
				def.getHeadingsDependencyPaths(_viewDetails.defView.m_headings, a);

				array.forEach(a, function(p) {
					paths.push(xml.path(PATH, p));
				});
			}
		},

		details: function(/*Context*/ctx, /*DOMNode*/domNode, /*Number?*/nColumns) {
			// summary: render Summary view for SMProduct, but do so in context of MCProduct
			ctx.setParam(csiHeading.CTX_LARGE_FORMAT, true);
			const dfd = this.generate(ctx, domNode, _viewDetails.defView.m_headings, locale.resource("CMDetails"), PATH, nColumns);
			ctx.setParam(csiHeading.CTX_LARGE_FORMAT, false);
			return dfd;
		},

		/**
		 * Render headings within given element with optional group name
		 * @param {Context} ctx 
		 * @param {HTMLElement} parentElement 
		 * @param {Heading[]} headings
		 * @param {string} [name] - group name 
		 * @param {string} [path] 
		 * @param {number} [nColumns]
		 * @return {Deferred<void> | undefined} 
		 */
		generate(ctx, parentElement, headings, name, path, nColumns) {
			if (!headings.length) {
				return;
			}

			if (path) {
				ctx.push(path);
			}

			const specBuilder = new SpecBuilder(ctx.getNodeType(), ctx);
			const specs = new Specs();
			const subs = headings.map((h) => specBuilder.getSpecForHeading(h));
			specs.add(new Spec({name, subs}));

			const dfd = _cg.generate(ctx, parentElement, specs, nColumns || 1);

			if (path) {
				ctx.pop();
			}

			return dfd;
		},

		reset: function(/*Node*/mcp) {
			// summary: load/reset custom views for both summary and details panes
			let dfds;

			if (_viewSummary) {
				_viewSummary.setViewNode(mcp);
				_viewDetails.setViewNode(mcp);

				dfds = [
					_viewSummary.refreshDefaultCustomView(),
					_viewDetails.refreshDefaultCustomView()
				];
			} else {
				_viewSummary = csiView.newView(def.getNodeViewDef(mcp, "CatalogSummary"), mcp, null, true);
				_viewDetails = csiView.newView(def.getNodeViewDef(mcp, "CatalogDetails"), mcp, null, true);

				dfds = [
					_viewSummary.startup(),
					_viewDetails.startup()
				];
			}

			return all(dfds);
		},

		summary: function(/*Context*/ctx, /*DOMNode*/domNode) {
			// summary: render Summary view for SMProduct, but do so in context of MCProduct
			ctx.setParam(csiHeading.CTX_LARGE_FORMAT, true);
			const dfd = this.generate(ctx, domNode, _viewSummary.defView.m_headings, locale.resource("CMSummary"), PATH);
			ctx.setParam(csiHeading.CTX_LARGE_FORMAT, false);
			return dfd;
		}
	};
});